import { WORKING_CONFIG } from "@/src/shared/config/workingTime";
import { nowInKyiv } from "@/src/shared/utils/dateTime";

const isWorkingTimeNow = (): boolean => {
    const now = nowInKyiv();
    const dayOfWeek = now.weekday;
    const { hour } = now;

    if (!WORKING_CONFIG.workingDays.includes(dayOfWeek)) {
        return false;
    }

    return hour >= WORKING_CONFIG.startHour && hour < WORKING_CONFIG.endHour;
};

export { isWorkingTimeNow };
